import styled from 'styled-components';
import { RadioList } from 'ui/radioList';
import { FormLabel } from 'ui/formField';
import { spacing, RouterLink2 } from 'ui/theme';
import { Row, TopText } from 'ui/radioList/RadioListStyles';

// Radio Select
export const StyledFormLabel = styled(FormLabel)`
  margin-bottom: ${spacing.half};
`;

export const StyledRadioList = styled(RadioList)`
  ${Row} {
    margin-bottom: 0;
  }
  ${TopText} {
    margin-top: 3px;
  } ;
`;

// List Select
export const ListSelectWrapper = styled.div`
  display: flex;
  justify-content: row;
  gap: ${spacing.base};
  margin-bottom: ${spacing.threeQuarter};
`;

export const StyledLink = styled(RouterLink2)`
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  margin-top: ${spacing.base};
  margin-left: ${spacing.quarter};
`;
